import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PasswordConfirmComponent } from '../../../../../../shared/components/password-confirm/password-confirm.component';
import { Validators } from "../../../../../../shared/validators";
import { MatDialog } from "@angular/material/dialog";
import { WithdrawRequestService } from '../../../services/withdraw-request.service';
import { TitledModalWithContentService } from "../../../../../../shared/services/titled-modal-with-content.service";
import { TranslateService } from '@ngx-translate/core';
import { FetchSellerBalanceService } from "../../../../seller-dashboard/fetch-seller-balance.service";
import { Balance } from '../../../../seller';
import { FormValidatorService } from '../../../../../../shared/services/form-validator.service';
import { CashOutBalanceNotifierService } from '../CashOutBalanceNotifier.service';
import { TwoFactorAuthOtpService } from 'src/app/shared/services/two-factor-auth/two.factor.auth.service';

@Component({
  selector: 'app-add-cash-out-wallet-request',
  templateUrl: './add-cash-out-wallet-request.component.html',
  styleUrls: ['./add-cash-out-wallet-request.component.scss']
})
export class AddCashOutWalletRequestComponent implements OnInit {
  formValidator: FormValidatorService;
  withdrawForm!: FormGroup;
  balanceObject = {} as Balance;

  constructor(
    private withdrawRequestService: WithdrawRequestService,
    private fetchBalanceService: FetchSellerBalanceService,
    public dialog: MatDialog,
    private titleModalService: TitledModalWithContentService,
    private translate: TranslateService,
    private cashoutBalanceNotifier:CashOutBalanceNotifierService,
    private twoFactorAuthOtpService: TwoFactorAuthOtpService
    ) {
    this.formValidator = new FormValidatorService();
  }

  async ngOnInit() {
    this.balanceObject = await this.fetchBalanceService.make();
    this.withdrawForm = this.formValidator.createForm([
      {
        fieldName: "required_amount",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Withdraw Amount"
            })
          },
          {
            validatorFn: Validators.max(this.balanceObject.avalibleBalance),
            message: this.translate.instant("FORMS.VALIDATION.MAXIMUM", {
              field: "Withdraw Amount",
              value: this.balanceObject.avalibleBalance
            })
          }
        ]
      }
    ]);
  }

  async onWithdrawl() {
    try {
      await this.twoFactorAuthOtpService.sendOtp("wallet");
      const dialogRef = this.dialog.open(PasswordConfirmComponent, {
        data: {
          operation: 'wallet',
        },
      });
      const result = await dialogRef.afterClosed().toPromise();
      if (!result?.status) {
        return;
      } else {
        const withdrawalParams = {
          amount: this.withdrawForm.value.required_amount,
          isCashOut: true,
          otpCode: result.otp ?? null
        };

        this.withdrawRequestService.setParams(withdrawalParams);
        const withdraw = await this.withdrawRequestService.make();
        if (withdraw) {
          this.balanceObject = await this.fetchBalanceService.make();
          this.cashoutBalanceNotifier.pushCashOutNotification(this.balanceObject);
          this.withdrawForm.reset();
          this.titleModalService.open({
            title: "Cashout Wallet Request",
            content: "Your Request is under review.",
            closeButtonName: "Close"
          });
        }
      }
    } catch (err) {
      console.log("error >>>>", err);
      if (err.faultyRequest.error.name === "CannotWithDrawException") {
        this.titleModalService.open({
          title: "An Error Occurred",
          content: "Your business can not withdraw.",
          closeButtonName: "Close"
        });
      }
      if (err.faultyRequest.error.name === "PendingCashoutAleadyExist") {
        this.titleModalService.open({
          title: "An Error Occurred",
          content: `${err.faultyRequest.error.message}`,
          closeButtonName: "Close"
        });
      }

      this.twoFactorAuthOtpService.handleErrors(err);
    }
  }

}
